
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M12 0c-.717 0-1.297.58-1.297 1.297v1.946a1.297 1.297 0 102.594 0V1.297C13.297.581 12.717 0 12 0zM5.348 3.513a1.297 1.297 0 00-1.835 1.835l1.382 1.381a1.297 1.297 0 101.834-1.834zm15.139 0a1.297 1.297 0 00-1.835 0l-1.381 1.382a1.297 1.297 0 101.834 1.834l1.382-1.381a1.297 1.297 0 000-1.835zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM1.297 10.703a1.297 1.297 0 100 2.594h1.946a1.297 1.297 0 100-2.594zm19.46 0a1.297 1.297 0 100 2.594h1.946a1.297 1.297 0 100-2.594zM6.729 17.27a1.297 1.297 0 00-1.834 0l-1.382 1.381a1.297 1.297 0 101.835 1.835l1.381-1.382a1.297 1.297 0 000-1.834zm12.376 0a1.297 1.297 0 10-1.834 1.834l1.381 1.382a1.297 1.297 0 101.835-1.835zM12 19.46c-.717 0-1.297.58-1.297 1.297v1.946a1.297 1.297 0 102.594 0v-1.946c0-.717-.58-1.298-1.297-1.298z","fill":"#232f63","fill-rule":"evenodd"}})])
          )
        }
      }
    